export function randomFruit(screenWidth, screenHeight, speedMultiplier = 1) {
  const fruitImages = ["apple.png", "orange.png", "banana.png"];
  const isBomb = Math.random() < 0.15;

  return {
    id: Math.random().toString(36).substring(7),
    x: Math.random() * (screenWidth - 100) + 50,
    y: screenHeight + 60,
    vx: (Math.random() - 0.5) * 6 * speedMultiplier,
    vy: -12 - Math.random() * 6 * speedMultiplier,
    sliced: false,
    type: isBomb ? "bomb" : "fruit",
    image: isBomb
      ? "bomb.png"
      : fruitImages[Math.floor(Math.random() * fruitImages.length)],
  };
}
